<template>
  <div class="section__inner section__inner--noRightpad">
    <div class="section__box section__box--nobg">
      <div class="section__head">
        <h2 class="box-title">{{ title }}</h2>
        <div class="item-img">
          <router-link
            :to="{
              name: 'ProductCategory',
              params: { type: currentType, title, id: categoryid }
            }"
            class="btn--outline btn--sm"
            :class="[currentLanguage === 'AR' ? 'rtlText' : '']"
          >
            {{ $t('button.seemore') }}
          </router-link>
        </div>
      </div>

      <Swiper class="swiper carousel-wrapper carousel-wrapper--nopad" v-bind="swiperProps">
        <SwiperSlide
          v-for="item in products"
          :key="item.product_id"
          :class="isBookType ? 'carousel-item card--v2 card--ebook' : 'carousel-item card--v2'"
        >
          <div
            class="item-img"
            @click="onLinkClick($event, {
              name: 'ProductDetails',
              params: { type: helpers.portal_name, productId: item.product_id }
            })"
          >
            <router-link
              :to="{
                name: 'ProductDetails',
                params: { type: helpers.portal_name, productId: item.product_id }
              }"
            >
              <img :src="item.icon_small" :alt="title" />
            </router-link>
          </div>

          <div class="item-data">
            <router-link
              :to="{
                name: 'ProductDetails',
                params: { type: helpers.portal_name, productId: item.product_id }
              }"
              @click="onLinkClick($event, {
                name: 'ProductDetails',
                params: { type: helpers.portal_name, productId: item.product_id }
              })"
            >
              <div>
                <h3 class="data-title">{{ item.title }}</h3>
                <div class="data-category">{{ item.short_description }}</div>
              </div>
            </router-link>

            <router-link
              class="item-btn"
              :to="{
                name: 'ProductDetails',
                params: { type: helpers.portal_name, productId: item.product_id }
              }"
              @click="onLinkClick($event, {
                name: 'ProductDetails',
                params: { type: helpers.portal_name, productId: item.product_id }
              })"
            >
              <div class="btn--next btn--primary btn--sm">
                <span v-if="item.type === 1" :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                  {{ $t('button.playGame') }}
                </span>
                <span v-else-if="item.type === 5" :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                  {{ $t('button.playVideo') }}
                </span>
                <span v-else :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                  {{ $t('button.download') }}
                </span>
              </div>
            </router-link>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'

import { helpers } from '../helper/portal_config'
import EventBus from '../helper/event_bus'

export default {
  name: 'CarouselB',
  props: ['products', 'title', 'categoryid'],
  components: { Swiper, SwiperSlide },
  data() {
    return {
      helpers: '',
      currentType: null,
      currentLanguage: '',
      swiperProps: {
        loop: false,
        slidesPerView: 1.5,
        spaceBetween: 15,
        slidesOffsetAfter: 30,
        breakpoints: {
          480: { slidesPerView: 2.2 },
          667: { slidesPerView: 2.6, spaceBetween: 15 },
          767: { slidesPerView: 3.5, spaceBetween: 15 },
          1200: {
            slidesOffsetAfter: 0,
            slidesPerView: 5,
            grabCursor: false,
            touchRatio: 0,
            spaceBetween: 25
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({ isLoggedIn: 'globals/isLoggedIn' }),
    isBookType() {
      return this.helpers.portal_name === 'Carefizz'
    }
  },
  methods: {
    onLinkClick(e, link) {
      if (!this.isLoggedIn) {
        e.preventDefault()
        EventBus.$emit?.('SHOW_SIGNIN_MODAL', link) || EventBus.emit?.('SHOW_SIGNIN_MODAL', link)
      }
    },
    getProductType() {
      (this.helpers.menu || []).forEach((item) => {
        if (item.isActive === true) this.currentType = item.type
      })
    },
    setCurrentLanguage() {
      const { host } = window.location
      const country = host.split('.')[0].slice(0, 2).toUpperCase()
      const map = helpers.countryDefaultLanguage || {}
      this.currentLanguage = (map.hasOwnProperty(country) ? map[country] : country).toUpperCase()
    }
  },
  created() {
    this.helpers = helpers
    this.getProductType()
    this.setCurrentLanguage()
  }
}
</script>

<style scoped>
.card--v2.card--ebook .item-img { height: 250px; }
@media (min-width: 1440px) { .card--v2.card--ebook .item-img { height: 300px; } }
@media (min-width: 1600px) { .card--v2.card--ebook .item-img { height: 380px; } }
@media (min-width: 1921px) { .card--v2.card--ebook .item-img { height: 430px; } }
</style>
